import script from "./ApiManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiManagement.vue?vue&type=script&setup=true&lang=js"

import "./ApiManagement.vue?vue&type=style&index=0&id=5163427c&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5163427c"]])

export default __exports__